/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// function updateVariantSelectors() {
//     const product_variant_selector_element = $('#product_variant_selector_element');
//     const product_variant_selector_element_mobile_container = $('#product_variant_selector_element_mobile_container');
//     const product_variant_selector_element_desktop_container = $('#product_variant_selector_element_desktop_container');
    
//     if ($(window).width() < 900) {
//         product_variant_selector_element.appendTo(product_variant_selector_element_mobile_container);

//     } else {
//         product_variant_selector_element.appendTo(product_variant_selector_element_desktop_container);
      
//     }
//   }
  
//   // Initial setup
//   updateVariantSelectors();
  
//   // Add a resize event listener
//   $(window).resize(function () {
//     updateVariantSelectors();
//   });

// const quantityUpButton = $('#quantityUpButton');
// const quantityDownButton = $('#quantityDownButton');
// let byteexQuantity = $('#byteexQuantity');

// quantityUpButton.click(() => {
//   let currentQuantity = parseInt(byteexQuantity[0].value);
//   currentQuantity = currentQuantity + 1;
//   byteexQuantity.val(currentQuantity);
//   console.log(currentQuantity);
// });

// quantityDownButton.click(() => {
//   let currentQuantity = parseInt(byteexQuantity[0].value);
//   if (currentQuantity > 1) {
//     currentQuantity = currentQuantity - 1;
//     byteexQuantity.val(currentQuantity);
//   }
// });

// Get the modal

// var byteexCardModal = document.getElementById("byteexCardModal");
// var byteexCardModalContainer = document.getElementById("byteexCardModalContainer");

// Get the button that opens the modal
var byteexModalButtonAddCart = document.getElementById("byteexModalButtonAddCart");

document.addEventListener('click', function (event) {
  // Get the ID of the clicked element
  var clickedElementId = event.target.id;
  if (
    clickedElementId == 'product_variant_selector_element_desktop_container'
  ) {
    closeCartModal();
  }
});

function openCartModal() {
  $('.byteex-variant-selector-image-title').css('display', 'flex');
  $('.byteex-form-quantity-container').css('display', 'flex');
  $('#byteex-modal-add-cart-button').css('display', 'block');
  $('#product_variant_selector_element_desktop_container').css({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    background: 'rgba(0,0,0,0.5)',
    display: 'flex',
    'flex-direction': 'column',
    'align-items': 'center',
    'justify-content': 'center',
    'z-index': 99,
  });
}

function closeCartModal() {
  $('.byteex-variant-selector-image-title').css('display', 'none');
  $('.byteex-form-quantity-container').css('display', 'none');
  $('#byteex-modal-add-cart-button').css('display', 'none');

  $('#product_variant_selector_element_desktop_container').css('all', 'unset');
}

$(window).resize(function () {
  if ($(window).width() < 1000) {
    $('.byteex-form-quantity-container').css('display', 'none');
  } else {
    $('.byteex-form-quantity-container').css('display', 'flex');
  }
});

function addToCart() {
  // Get the form element
  var form = document.getElementById('cartForm');

  // Set the form's action to "/cart/add"
  form.action = '/cart/add';

  // Submit the form
  form.submit();
}

function buyNow() {
  // Get the form element
  var form = document.getElementById('cartForm');

  // Set the form's action to your "Buy now" action URL
  form.action = '/cart/add';

  // Submit the form
  form.submit();
}

function priceTextToNumber(value) {
  const trimmedValue = value.trim();
  const parsedValue = parseFloat(trimmedValue.replace(/[^0-9.-]+/g, ''));
  return parsedValue;
}

function byteexChangeVariant(option, index) {  
  const checkedRadios = document.querySelectorAll('.block-swatch__radio:checked');
  let imageIndex = null;
  if (checkedRadios.length > 1) {
    let selectedModel = '';
    let selectedStyle = '';
    checkedRadios.forEach((radio) => {
      if (radio.dataset.optionName === "Model") {
        selectedModel = radio.value;
      }
      if (radio.dataset.optionName === "Style" || radio.dataset.optionName === "Color") {
        selectedStyle = radio.value;
      }
    });
    const result = window.variant_images_data.find(
      item => item.style === selectedStyle && item.model === selectedModel
    );
    if (result) {
      imageIndex = result.image_index;
    }
  } 
  else if ((option === 'Style' || option === 'Color') && typeof index !== 'undefined') {
    imageIndex = index;
  }
  if (imageIndex !== null && imageIndex >= 0) {
    $('.byteex-main-slider').slick('slickGoTo', imageIndex); 
  } else {
    console.warn('Not found imageIndex byteexChangeVariant', { option, index, checkedRadios });
  }
}

// function byteexChangeVariant(option, index) {
//   const salePrice = priceTextToNumber($('.price--highlight').text());
//   const regularPrice = priceTextToNumber($('.price--compare').text());
//   // Calculate the discount percentage

//   // Display the discount percentage in the console (you can also use it as needed)

//   //Switching between variant images - code in byteex-product-gallery.liquid
//   if (option === 'Style' && window.variant_images_count === window.product_colors_count) {
//     $('.byteex-main-slider').slick('slickGoTo', index); 
//   }
// }

function getSalePercentage(salePrice, regularPrice) {
  var discountPercentage = ((regularPrice - salePrice) / regularPrice) * 100;
  return Math.ceil(discountPercentage.toFixed(2));
}